import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEO from '@/components/feature/SEO';
import VideoCard from '@/pages/home/components/VideoCard';
import { allVideos, categories } from '@/mocks/videos';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const videos = allVideos.filter((v) => v.categorySlug === slug);
  const catName = category?.name || '分类';

  const catSEO = {
    title: `${catName} - 棒棒TV | 高清免费在线观看`,
    description: `棒棒TV为您提供海量${catName}资源，高清不卡顿免缓冲流畅播放。最新${catName}全集免费在线观看，每日更新。`,
    keywords: `${catName},${catName}全集,${catName}在线观看,免费${catName},棒棒TV,高清视频`,
    canonicalUrl: `https://bangbangtv.com/category/${slug}`,
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: `${catName} - 棒棒TV`,
        url: `https://bangbangtv.com/category/${slug}`,
        description: `棒棒TV为您提供海量${catName}资源，高清不卡顿免缓冲流畅播放。`,
        isPartOf: {
          '@type': 'WebSite',
          name: '棒棒TV',
          url: 'https://bangbangtv.com',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://bangbangtv.com' },
          { '@type': 'ListItem', position: 2, name: catName },
        ],
      },
    ],
  };

  return (
    <>
      <SEO data={catSEO} />
      <ScrollToTop />
      <Navbar />

      <main>
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: catName },
          ]}
        />

        <section className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="bg-background-100 rounded-xl p-4 md:p-6 mb-6">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary-500 flex items-center justify-center">
                <i className={`${category?.icon || 'ri-vidicon-line'} text-white text-lg md:text-xl`}></i>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading">
                  {catName}
                </h1>
                <p className="text-sm text-foreground-500 mt-0.5">
                  共 {videos.length} 部作品
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-200 text-foreground-400 hover:text-foreground-200 hover:bg-background-300'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5 pb-12">
            {videos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>

          {videos.length === 0 && (
            <div className="text-center py-20">
              <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-background-200 flex items-center justify-center">
                <i className="ri-emotion-sad-line text-3xl text-foreground-500"></i>
              </div>
              <p className="text-foreground-500">暂无相关内容</p>
            </div>
          )}
        </section>
      </main>

      <Footer />
    </>
  );
}